import { useFilter } from 'facades'
import fetcher from 'request/stylists/ranking'
import Site from 'components/common/intro/site'
import Faq from 'components/common/intro/faq'
import Row from 'components/common/stylist/row'
import Reviews from './reviews'
//import SystemPerformance from 'components/common/system-performance'

export default function Stylists({ breadcrumbs, category }) {
  const { key, getConditionParams, getConditionTagIds, getPathLocations } = useFilter()
  const { state, mutate } = useStatic({
    records: [],
    fetching: true,
    loadMoreClick: null
  })
  const t = useI18n()

  useBodyScroll({
    state,
    mutate,
    isReady: !!key,
    reset: true,
    startLimit: 6,
    limit: 18,
    showLoadMore: true,
    fetcher,
    fetcherParams: () => ({
      //conditionParams: { serviceId: 1, ...getConditionParams() },
      conditionParams: getConditionParams(),
      conditionTagIds: getConditionTagIds()
    }),
    resolver: stylist => {
      if (!stylist.studio) return
      state.records.push(stylist)
    }
  }, [key])

  const renderBody = () => state.records.map(stylist => (
    <Row
      key={ stylist.id }
      stylist={ stylist }
    />
  ))

  const renderLoading = () => {
    if (state.fetching) return <div className='py-5'><C.Loading /></div>
    if (!state.records.length) return <div className='py-5 text-center text-gray-600'>{ t('page:stylists.noResult') }</div>
    if (state.scrollConfig.isFinish) return
    return (
      <div className='pb-5 flex justify-center'>
        <C.Button className='w-[90%] md:w-[16rem]' onClick={ state.loadMoreClick }>載入更多</C.Button>
      </div>
    )
  }

  const renderBreadcrumbs = () => {
    if (!breadcrumbs) return null
    return (<div className='pt-6'>
      <C.Breadcrumb list={ breadcrumbs } />
    </div>
    )
  }

  // const renderCategoryFilter = () => {
  //   const categoryChange = serviceCategory => updateFilter({ key: 'service', value: serviceCategory })

  //   return (
  //     <div className='container flex flex-wrap tracking-widest pt-6'>
  //       { store.stylistEventFilterCategories.map(key => {
  //         const isActive = key === category
  //         const textStyle = () => {
  //           if (isActive) return 'text-white'
  //           return 'text-gray-700'
  //         }
  //         const bgStyle = () => {
  //           if (isActive) return 'bg-gray-700'
  //           return 'border'
  //         }
  //         return (
  //           <div key={ key }
  //             className={ cn('relative mr-3 mb-3 text-sm text-[0.8rem] cursor-pointer py-2 text-center', textStyle()) }
  //             onClick={ () => categoryChange(key) }
  //           >
  //             <div className={ cn('absolute top-0 bottom-0 left-0 right-0 rounded-full', bgStyle()) } />
  //             <div className='relative px-5'>
  //               { t(`common:service.category.${key}`) }
  //             </div>
  //           </div>
  //         )
  //       }) }
  //     </div>
  //   )
  // }

  const tabClick = () => {
    const { city, district } = getPathLocations()
    h.path.go.stylistEvents({ category, city, district })
  }

  return (
    <>
      <div className='container'>
        { renderBreadcrumbs()}
      </div>
      <div className='container flex justify-center border-b pt-3 mb-5'>
        <div className='flex flex-1 md:max-w-[22rem] tracking-widest'>
          <div className='py-3 cursor-pointer flex-1 text-center border-b-2 border-cyan-800'>
            <div className='text-cyan-800'>{ t('common:breadcrumb.popularStylists') }</div>
          </div>
          <div className='py-3 cursor-pointer flex-1 text-center'>
            <div onClick={ tabClick } className='text-gray-500'>{ t('common:breadcrumb.stylistEvents') }</div>
          </div>
        </div>
      </div>
      {/* { renderCategoryFilter() } */}
      { renderBody() }
      { renderLoading() }

      <Reviews
        title='用戶評價'
        queryType='guarantee'
        isReadyKey={ key }
        getConditionParams={ getConditionParams }
        getConditionTagIds={ getConditionTagIds }
      />

      <Site />
      <div className='bg-gray-50'>
        <Faq />
      </div>
    </>
  )
}
